import { withWixStyle } from './useWixStyle';
import { withNativeStyle } from './useNativeStyle';
import { withLiveSiteStyle } from './useLiveSiteStyle';
export const themeStrategy = ({ useWixStyles, useNativeStyles, ...rest } = {}, isBmPlatform = false) => {
    return useNativeStyles
        ? withNativeStyle(rest)
        : useWixStyles ?? isBmPlatform
            ? withWixStyle(rest)
            : withLiveSiteStyle(rest);
};
//# sourceMappingURL=themeStrategy.js.map